<template>
  <div class="leco-content">
    <div class="redirect-msg">録画ページにリダイレクトします。</div>
    <loading :active.sync="isPostLoading"></loading>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/common/config";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "web-meeting-rec-watch-redirect",
  data() {
    return {
      logger: this.$store.state.logger,
      isPostLoading: true
    };
  },
  components: {
    loading: Loading
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    // トレーニング予定情報を取得し録画URLを取得
    const trainingPlanId = this.$route.params.id;
    this.logger.debug("トレーニング予定を取得。ID=" + trainingPlanId);
    let api_url = API_BASE_URL + "training-plannings/" + trainingPlanId;
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug("result:\n" + JSON.stringify(result));
        if ("statusCode" in result.data) {
          //statusCodeが200なら画面表示
          if (result.data.statusCode == 200) {
            this.logger.info("トレーニング予定取得成功");
            var web_meeting_rec_url = result.data.body.share_url;
            if (web_meeting_rec_url == null) {
              this.logger.error(
                "指定されたトレーニング予定IDの録画は存在しません。training_id=" +
                  trainingPlanId
              );
            } else {
              this.logger.debug(
                "Teams録画URL取得できました。share_url=" + web_meeting_rec_url
              );

              // トレーニング予定情報を取得し録画URLを取得
              const trainingPlanId = this.$route.params.id;
              this.logger.debug("トレーニング予定を取得。ID=" + trainingPlanId);
              let api_url =
                API_BASE_URL +
                "training-plannings/" +
                trainingPlanId +
                "/participants";
              axios
                .post(api_url, "", {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      this.$store.getters.currentUser.idToken.jwtToken
                  }
                })
                .then((result) => {
                  if ("statusCode" in result.data) {
                    //statusCodeが200なら予実一覧に遷移（今登録したものを確認できる）
                    if (result.data.statusCode == 200) {
                      // Teamsにリダイレクト
                      window.location.href = web_meeting_rec_url;
                    } else {
                      this.logger.error("API status 500 error");
                      this.logger.error(JSON.stringify(result));
                      this.$router.push("/system-error500");
                    }
                  } else {
                    this.logger.error("API unexpected response format error");
                    this.logger.error(JSON.stringify(result));
                    this.$router.push("/system-error500");
                  }
                })
                .catch((error) => {
                  this.logger.error("API(get) error");
                  this.logger.error(error);
                  this.$router.push("/system-error500");
                });
              this.isPostLoading = false;
              return;
            }
          } else {
            // 200以外はシステム例外画面表示
            this.logger.error(
              "API(get) return statusCode=" +
                result.data.statusCode +
                ", errorMessages=" +
                result.data.errorMessages.message +
                ", uri=" +
                api_url
            );
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error(
            "API(get) unexpected return response=" +
              JSON.stringify(result) +
              ", uri=" +
              api_url
          );
          this.$router.push("/system-error500");
        }
      })
      .catch((error) => {
        this.logger.error("API(get) error");
        this.logger.error(error);
        this.$router.push("/system-error500");
      });
  }
};
</script>

<style scoped>
.auth-page {
  flex: 1;
}

.redirect-msg {
  margin-top: 30px;
}
</style>
